import { type MainTranslationFunction } from '@autone/translations';

import { type APP_NAME } from '../../../../consts';
import { type AssortmentCustomColumnsConfig } from '../AssortmentCustomColumnsMenu.types';

export const getProductLocationsTableCustomColumnsConfig = (
  t: MainTranslationFunction<typeof APP_NAME>,
): AssortmentCustomColumnsConfig<'productLocationsTable'> => {
  return {
    storageKey: 'productLocationsTable.extrasMenu.customColumns',
    columnOptions: [
      {
        id: 'permanent',
        translatedDisplayName: t('custom-columns-groups.permanent'),
        columns: [
          {
            id: 'location_desc',
            translatedDisplayName: t('table-columns.location'),
          },
        ],
      },
      {
        id: 'assortment',
        translatedDisplayName: t('custom-columns-groups.assortment'),
        columns: [
          {
            id: 'current_assortment',
            translatedDisplayName: t('table-columns.current-assortment'),
          },
          {
            id: 'assorted_start_date',
            translatedDisplayName: t(
              'table-columns.scheduled-assortment-start',
            ),
          },
          {
            id: 'assorted_end_date',
            translatedDisplayName: t('table-columns.scheduled-assortment-end'),
          },
          {
            id: 'initial_allocation',
            translatedDisplayName: t('table-columns.initial-allocation'),
          },
          {
            id: 'location_cluster',
            translatedDisplayName: t.withCustomer(
              'table-columns.$location-cluster',
            ),
          },
        ],
      },
      {
        id: 'sales',
        translatedDisplayName: t('custom-columns-groups.sales'),
        columns: [
          {
            id: 'total_sales_units',
            translatedDisplayName: t('table-columns.total-sales-units'),
          },
          {
            id: 'total_sales_value',
            translatedDisplayName: t('table-columns.total-sales-value'),
          },
          {
            id: 'first_sale_date',
            translatedDisplayName: t('table-columns.first-sale-date'),
          },
          {
            id: 'latest_sale_date',
            translatedDisplayName: t('table-columns.last-sales-date'),
          },
        ],
      },
      {
        id: 'inventory',
        translatedDisplayName: t('custom-columns-groups.inventory'),
        columns: [
          {
            id: 'current_units',
            translatedDisplayName: t('table-columns.current-units'),
          },
          {
            id: 'pending_from_production_units',
            translatedDisplayName: t(
              'table-columns.pending-from-production-units',
            ),
          },
          {
            id: 'warehouse_units',
            translatedDisplayName: t('table-columns.warehouse-units'),
          },
          {
            id: 'parent_location_pending_from_production_units',
            translatedDisplayName: t(
              'table-columns.parent-location-pending-from-production-units',
            ),
          },
        ],
      },
    ],
    columnPinning: {
      leftPinned: ['location_desc'],
    },
    permanentColumns: ['location_desc'],
  } as const;
};
